import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    firestoreProduction: {
      apiKey: "AIzaSyBbjZxeQSPvgj_ve0OuNUNwNtBRQO14mK8",
      authDomain: "steady-tracer-232015.firebaseapp.com",
      databaseURL: "https://steady-tracer-232015.firebaseio.com",
      projectId: "steady-tracer-232015",
      storageBucket: "steady-tracer-232015.appspot.com",
      messagingSenderId: "188097333372",
      appId: "1:188097333372:web:9ce01e07d003338a0da1f9",
      measurementId: "G-GKVD6LK6ZR"
    },
    firestoreDevelopment: {
      apiKey: "AIzaSyAWITDOfTpZ0KVtdM8B3uHi3Q3DBSLIaXA",
      authDomain: "poolside-os-test.firebaseapp.com",
      databaseURL: "https://poolside-os-test.firebaseio.com",
      projectId: "poolside-os-test",
      storageBucket: "poolside-os-test.appspot.com",
      messagingSenderId: "759950105449",
      appId: "1:759950105449:web:43afe8e60c6e1d3f847bf8"
    },
  },
  getters: {
    firestoreConfig: (state) => (payload) => {
      let capitalised = payload.charAt(0).toUpperCase() + payload.slice(1);
      return state[`firestore${capitalised}`];
    },
  },
});

export default store;
